/**
 * Cache keys for the notifications feed. Nothing fetches it today - the admin
 * panel was its only surface (WEB-3361) - but task actions and view signing
 * still invalidate under this prefix, so a future feed reads fresh data.
 */
export const notificationsKeys = {
  /** Prefix for invalidating every notifications query. */
  all: ["notifications"] as const,
};
